import React, { Component, Fragment } from 'react';
import { inject, observer } from 'mobx-react';
import LoadingSpinner from '../loadingSpinner/';
import List from './list';
import Filter from './filter';
import Message from '../message';

@inject('lineStore', 'accountStore')
@observer
class ScheduleContainer extends Component {

  handlerClose = () => {
  	this.props.lineStore.schedule.clearResult();
  }
    
	render() {

		if (!this.props.lineStore.line.mode) return false;

		const {isLoading, result} = this.props.lineStore.schedule;
		const {basketPosition} = this.props.accountStore.accountSettings;
		const {shortMenu} = this.props.lineStore;

		return (
			<div ref={this.lineContainer} className={`line-central-column l-c-c-c-s ${ basketPosition == 'right' ? 'line-central-column-short-right' : ''} ${shortMenu && basketPosition == 'right' ? 'line-central-column-short-left' : ''}`} id="line-central-column" >
				{ isLoading ? 
				<div>
					<LoadingSpinner />
				</div> :
				<div className="schedule-index">
					<Filter />
					{result.status ? <Message text={result.text} type={result.type} onClose={this.handlerClose}/> : ''}
	        <List />
	      </div>
	    }
	    </div>
		) 
	}
}

export default ScheduleContainer;


// WEBPACK FOOTER //
// ./src/components/schedule/index.jsx